import DateTileDirective from './DateTileDirective';

export default angular.module('edge.platform.widgets.datetile', []).directive('gwDateTile', DateTileDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/datetile/module.js
// module id = 1100
// module chunks = 0